import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PageHeaderComponent } from 'quest-atlas-angular-components';

@Component({
    selector: 'app-privacy-policy',
    standalone: true,
    imports: [CommonModule, PageHeaderComponent],
    templateUrl: './privacy-policy.component.html',
    styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent {
  constructor(private router: Router) { }

  public navigateBack(): void {
    this.router.navigate(['']);
  }
}
